import { B2CContenido, B2CContenidoInterface } from "./B2CContenido.model";
import { B2CPortalProducto, B2CPortalProductoInterface } from "./B2CPortalProducto.model";
import { Color, ColorInterface } from "./color.model";
import { Fondo, FondoInterface } from "./fondo.model";
import { Logo, LogoInterface } from "./logo.model";
import { Pie, PieInterface } from "./pie.model";

export interface B2CAspectoInterface {
    logo:LogoInterface;
    color:ColorInterface;
    fondo:FondoInterface;
    pie:PieInterface;
    contenido:B2CContenidoInterface;
    portalProducto:B2CPortalProductoInterface
}

export class B2CAspecto {
    constructor(
        public logo:Logo,
        public color:Color,
        public fondo:Fondo,
        public pie:Pie,
        public contenido:B2CContenido,
        public portalProducto:B2CPortalProducto
    ) {
    }
}

export class B2CAspectoMaker {
    static createInterface(event:B2CAspectoInterface):B2CAspectoInterface {
        return { logo: event.logo, color: event.color, fondo: event.fondo, pie: event.pie,contenido:event.contenido,portalProducto:event.portalProducto  }
    }

    static create(event: B2CAspecto) {
        return new B2CAspecto( event.logo, event.color, event.fondo, event.pie,event.contenido, event.portalProducto );
    }
}